import { useTranslation } from 'react-i18next';
import { Badge, IBadgeProps } from '@/common/components/Badge/Badge';
import { IInsuranceMember } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export const StatusBadge = ({
  person,
  badgeProps,
}: {
  person: IInsuranceMember;
  badgeProps?: Partial<IBadgeProps>;
}) => {
  const { t } = useTranslation();
  switch (person.status) {
    case 'active':
      return (
        <Badge status="success" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.active')}
        </Badge>
      );
    case 'pending':
      return (
        <Badge status="info" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.pending')}
        </Badge>
      );
    case 'removed':
    case 'left':
      return (
        <Badge status="disabled" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.removed')}
        </Badge>
      );
    case 'leaving':
      return (
        <Badge status="warning" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.leaving')}
        </Badge>
      );
    case 'removing':
      return (
        <Badge status="warning" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.removing')}
        </Badge>
      );
    case 'cancelled':
      return (
        <Badge status="disabled" emphasis="soft" {...badgeProps}>
          {t('dashboard.insurance.person.status.cancelled')}
        </Badge>
      );
    default:
      return null;
  }
};
